import * as field         from './field';
import * as form          from './form';
import * as category      from './category';
import * as qualifier     from './qualifier';
import * as imageCategory from './imageCategory';

export default ({
  field,
  form,
  category,
  qualifier,
  imageCategory,
});